<template>
  <div>
    <!-- 基金信息 -->
    <div class="common-box border-t0 margin-b5" style="overflow: hidden;min-height:0;">
      <!-- 持仓收益 -->
      <div class="holdProfit fl">
        <div class="fundName clearfix">
          <div class="fl clearfix" style="max-width: 330px;">
             <div class="fundName1 fl">{{singleMessage.fundcodename}}</div>
             <div class="fundName2 fl">{{singleMessage.fundcode}}</div>
          </div>
          <div class="fundName3 fr" @click="dialogVisable = true">?</div>
        </div>
        <ul class="profit">
          <li>
            <p class="text1">当前市值(元)</p>
            <p class="text2">{{singleMessage.mktvalue}}</p>
          </li>
          <li>
            <p class="text1">昨日收益</p>
            <p class="text2" :class="singleMessage.yestdayprofit >= 0? 'rColor':'gColor'">{{singleMessage.yestdayprofit}}</p>
          </li>
          <li>
            <p class="text1">持有收益</p>
            <p class="text2" :class="singleMessage.phaseprofit >= 0? 'rColor':'gColor'">{{singleMessage.phaseprofit>=0?'+' + singleMessage.phaseprofit:singleMessage.phaseprofit}}</p>
          </li>
        </ul>
      </div>
      <!-- 持仓信息 -->
      <div class="holdInformation fl">
        <div class="informationTit">
          <div class="fundName1 fl">持仓信息</div>
          <div class="fundOption btnTwo fr">
            <el-button type="primary" v-if="singleMessage.fundstatus == '0' ||singleMessage.fundstatus == '1'||singleMessage.fundstatus == '6'||singleMessage.fundstatus == '7'||singleMessage.fundstatus == '8'||singleMessage.fundstatus == 'b'" @click="buyClick">买入</el-button>
            <el-button type="primary" v-else class="disable">买入</el-button>
            <el-button type="primary" v-if="singleMessage.fundstatus == '0' ||singleMessage.fundstatus == '6'||singleMessage.fundstatus == '7'||singleMessage.fundstatus == '8'||singleMessage.fundstatus == 'b'" @click="fixedInvest">定投</el-button>
            <el-button type="primary" v-else class="disable">定投</el-button>
            <el-button type="primary" v-if="singleMessage.availbal != '0.00' && (singleMessage.fundstatus == '0' ||singleMessage.fundstatus == '5'||singleMessage.fundstatus == '7'||singleMessage.fundstatus == '8'||singleMessage.fundstatus == 'b')" @click="sellClick">卖出</el-button>
            <el-button type="primary" v-else class="disable">卖出</el-button>
            <el-button type="primary" v-if="singleMessage.availbal != '0.00'" @click="transformClick">转换</el-button>
            <el-button type="primary" v-else class="disable">转换</el-button>
            <Reback class="row-one-fr" @click.native="returnClick"></Reback>
          </div>
        </div>
        <ul class="informationCount">
          <li v-if="singleMessage.fundtype=='2'">
            <p>七日年化收益：<span>{{parseFloat(singleMessage.growthrate *100).toFixed(2)}}%</span></p>
            <p>万份收益：<span>{{parseFloat(singleMessage.fundincomeunit).toFixed(2)}}</span></p>
          </li>
          <li v-else>
            <p>最新净值：<span>{{parseFloat(singleMessage.nav).toFixed(4)}}</span></p>
            <p>日张跌幅：<span>{{parseFloat(singleMessage.dailyincreases *100).toFixed(2)}}%</span></p>
          </li>
          
          <li>
            <p>基金份额：<span>{{parseFloat(singleMessage.fundvol).toFixed(2)}}</span></p>
            <p>可用份额：<span>{{parseFloat(singleMessage.availbal).toFixed(2)}}</span></p>
          </li>
          <li v-if="singleMessage.fundtype=='2'">
            <p>估算未付收益：<span>{{parseFloat(singleMessage.income).toFixed(2)}}</span></p>
            <p>持有收益：<span>{{parseFloat(singleMessage.phaseprofit).toFixed(2)}}</span></p>
          </li>
          <li v-else>
            <p>摊薄成本：<span>{{parseFloat(singleMessage.phasecostmoney).toFixed(2)}}</span></p>
            <p>单位成本：<span>{{parseFloat(singleMessage.costprice).toFixed(2)}}</span></p>
          </li>
          <li>
            <p>持有收益率：<span>{{singleMessage.syl + '%'}}</span></p>
            <p>
                分红方式：
                <span v-if="singleMessage.fundtype=='2'">{{singleMessage.dividendmethod == 1? '现金分红':'红利再投'}}<img src="../../../assets/images/2021_cl.png" alt=""></span>
                <span v-else class="bonus" @click="bonusAgainClick">{{singleMessage.dividendmethod == 1? '现金分红':'红利再投'}}<img src="../../../assets/images/2021_cl.png" alt=""></span>
                <i>{{singleMessage.fundtype=='2'?'货币基金不能设置分红方式':' 注：设置分红方式'}}</i>
            </p>
          </li>
        </ul>
        
      </div>
    </div>
    <!-- 基金记录 -->
    <PublicRecord :singleFundcode="singleMessage.fundcode" :singleFundMessage="singleMessage"></PublicRecord>
    <!-- 弹框 -->
    <el-dialog class="dialog-single-two" title="说明" :visible.sync="dialogVisable">
      <section class="instruction">
        <div class="instruction-li">
          <p class="instruction-li-title aColor">昨日收益</p>
          <p class="instruction-li-con">昨日收益是指，因连续两个交易日的基金净值变动而引起的浮动收益。</p>
          <p class="instruction-li-tip">昨日收益=（昨日基金净值-前日基金净值）× 昨日份额</p>
          <p class="instruction-li-tip">提示：货币基金的昨日收益是根据万份收益率计算。</p>
        </div>
        <div class="instruction-li">
          <p class="instruction-li-title aColor">持有收益</p>
          <p class="instruction-li-con">持有收益是指，这只基金持仓交易以来（份额不为零）产生收益的总和。</p>
          <p class="instruction-li-con">
            提示：持有收益的数据会在每日净值披露后更新。如果当日有交易确认，手续费也会计入当日盈亏。特殊情况（分红、折算等）下盈亏数据可能不准确，系统会在分红、折算交易确认后，自动修复历史数据。
          </p>
        </div>
        <div class="instruction-li">
          <p class="instruction-li-title aColor">持有收益率</p>
          <p class="instruction-li-con">持有收益率 = （持有收益 ÷ 摊薄成本 ）× 100%</p>
          <p class="instruction-li-tip">提示：数据会在每日净值披露后更新。摊薄成本是指，经过多次的交易后（非0份额）的投资成本。</p>
        </div>
        <div class="instruction-li">
          <p class="instruction-li-title aColor">累计收益</p>
          <p class="instruction-li-con">累计收益是指，有史以来收益的总和。</p>
          <p class="instruction-li-tip">提示：此收益为历史收益的总和，即使目前空仓，也会显示累计收益。</p>
        </div>
        <div class="instruction-li">
          <p class="instruction-li-title aColor">单位成本</p>
          <p class="instruction-li-con">单位成本是您当前持有该基金的每份平均成本。</p>
          <p class="instruction-li-tip">摊薄成本=单位成本×基金份额</p>
          <p class="instruction-li-tip">提示：如果卖出的净值高于当前单位成本，卖出确认后单位成本会下降。</p>
        </div>
        <div class="instruction-li">
          <p class="instruction-li-title aColor">摊薄成本</p>
          <p class="instruction-li-con">摊薄成本是指，经过多次的交易后（非0份额）的投资成本。</p>
          <p class="instruction-li-tip">摊薄成本=单位成本×基金份额</p>
          <p class="instruction-li-tip">提示：现金分红会记入摊薄成本中。</p>
        </div>
        <div class="instruction-li">
          <p class="instruction-li-title aColor">未付收益</p>
          <p class="instruction-li-con">未付收益，是指当前货币基金的未结转收益。估算未付收益是每日已获得收益的累加估算。</p>
          <p class="instruction-li-tip">单日估算未付收益=(份额/10000) * 每万份收益 。</p>
          <p class="instruction-li-tip">提示：货币基金每日都会有收益，但每月结转一次。</p>
        </div>
      </section>
    </el-dialog>
    <!-- 功能开发中 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable1" :show-close="false">
      <img src="../../../assets/images/development.png" alt="" style="width:120px;height:110px;">
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="dialogVisable1 = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PublicRecord from '../../../views/myAssets/publicFunds/publicRecord.vue';
export default {
  name: "fundHoldDetails",
  components: {
    PublicRecord
  },
  data () {
    return {
      singleMessage: '',//传递
      dialogVisable: false,
      dialogVisable1: false,
    }
  },
  created () {
    this.singleMessage = this.$route.params.message
    // console.log(this.singleMessage);
  },
  methods: {
    // 分红跳转
    bonusAgainClick () {
      this.$router.push({
        name: 'fundHoldBonusAgain',
        params: {
          message: this.singleMessage
        }
      })
    },
    returnClick () {
      this.$router.push({
        name: 'myAssets'
      })
    },
    fixedInvest () {
      this.$router.push({
        name: 'fixedBuyOpen',
        params: {
          message: this.singleMessage,
          name: 'fundHoldDetails',
        }
      })
    },
    buyClick () {
      this.$router.push({
        name: 'publicBuy',
        params: {
          fundMessage: this.singleMessage
        }
      })
    },
    sellClick () {
      this.$router.push({
        name: 'publicFundHoldSell',
        params: {
          fundMessage: this.singleMessage
        }
      })
    },
    transformClick () {
      this.$router.push({
        name: 'publicFundTransform',
        params: {
          fundMessage: this.singleMessage
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.holdProfit {
  width: 33%;
  // height: 55px;
  box-sizing: border-box;
  // background: pink;
  border-right: 1px dashed #bfbfbf;
  .fundName {
    position: relative;
    margin-bottom: 25px;
    line-height: 26px;
    .fundName1 {
      border-left: 4px solid #246ead;
      padding-left: 8px;
      font-size: 20px;
      font-weight: bold;
      color: #246ead;
    }
    .fundName2 {
      width: 68px;
      height: 20px;
      line-height: 20px;
      background: #91b6d5;
      color: #fff;
      text-align: center;
      margin-left: 12px;
      margin-top: 3px;
    }
    .fundName3 {
      position: absolute;
      right: 15px;
      top: 3px;
      width: 20px;
      height: 20px;
      background: #246ead;
      vertical-align: middle;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 20px;
      cursor: pointer;
    }
  }
  .profit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    li {
      width: 33.33%;
      text-align: center;
      .text1 {
        color: #666;
      }
      .text2 {
        font-size: 24px;
        font-weight: bold;
        margin-top: 12px;
      }
    }
  }
}
.holdInformation {
  position: relative;
  width: 67%;
  padding-left: 20px;
  box-sizing: border-box;
  .informationTit {
    height: 26px;
    margin-bottom: 25px;
    line-height: 26px;
    .fundName1 {
      position: relative;
      box-sizing: border-box;
      border-left: 4px solid #246ead;
      padding-left: 8px;
      font-size: 20px;
      font-weight: bold;
      color: #246ead;
    }
    .fundOption {
      .el-button {
        width: 55px;
        height: 22px;
      }
    }
  }
  .informationCount {
    display: flex;
    justify-content: space-between;
    margin-left: 12px;
    li {
      p span {
        color: #ed0000;
        img {
          margin-left: 8px;
          margin-top: -3px;
        }
      }
      p:nth-child(2) {
        margin-top: 19px;
      }
      p i {margin-left: 10px;font-size: 12px;}
      .bonus {
        cursor: pointer;
        
      }
    }
  }
}
</style>